/**
 * Platform deep-link constants and utilities.
 *
 * ADR-023: all platform/deep-link infrastructure lives in miniapp/src/platform/.
 * BOT_LINK is the single source — import from here, never declare locally.
 *
 * SSOT: this file. Consumers: HelpScreen, ProductScreen, HomeScreen/ActiveTaskPill.
 */
export const BOT_LINK = import.meta.env.VITE_BOT_USERNAME
  ? `https://t.me/${import.meta.env.VITE_BOT_USERNAME}`
  : 'https://t.me/awardybot';

/**
 * Browser-level fallback for opening external URLs when no PlatformAdapter
 * is available (e.g. during test rendering outside PlatformProvider).
 * All production call sites MUST prefer `platform.openExternal(url)` instead.
 */
export function openExternalFallback(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
